import React from 'react';
import { Link } from '../link';
import { getLinkInformation } from '../../utils/functions';
import './MainHeader.scss';
import Icon from '../../atoms/icon';
import { Wrapper } from '../../utils/components';

function MainHeaderIcon({
  labelItem,
  iconItem,
  pageTitleItem,
  internalLinkItem,
  externalLinkItem,
}) {
  const linkInformation = getLinkInformation(
    internalLinkItem,
    externalLinkItem,
    labelItem,
    pageTitleItem
  );

  return (
    <>
      {iconItem !== '' && (
        <Wrapper
          aria-label={labelItem}
          className='main-header__item main-header__item--mobile'
          tag='span'
          component={linkInformation.link && Link}
          to={linkInformation.link}
        >
          <span className='main-header__svg'>
            <Icon icon={iconItem} />
          </span>
        </Wrapper>
      )}
    </>
  );
}

export default MainHeaderIcon;
